import { BookkeepingItem } from '../types/bookkeepingItem'
import { roundAmount } from './roundAmount'

export const getCrossCurrencyExpectedAmount = (selectedItems: BookkeepingItem[]): number => {
  const signedTotal = selectedItems.reduce((sum, item) => {
    const signedAmount = item.side === 'debit' ? item.amount : -item.amount
    return sum + signedAmount
  }, 0)

  return roundAmount(Math.abs(signedTotal))
}
